import { AlertTriangle, Layers, Clock, GraduationCap } from "lucide-react";

const points = [
  {
    icon: Layers,
    title: "Too many systems",
    desc: "Multiple devices and apps slowing down yard work — paper, scanners, spreadsheets, all out of sync.",
  },
  {
    icon: AlertTriangle,
    title: "Errors creeping in",
    desc: "Manual entry and disconnected tools mean wrong tags, missed weights, and rework after the fact.",
  },
  {
    icon: GraduationCap,
    title: "Hard to onboard staff",
    desc: "New hands lose hours just figuring out which tool to pick up — never mind doing it right.",
  },
  {
    icon: Clock,
    title: "Data lag",
    desc: "What you capture in the yard isn't usable until someone gets back to a desk and uploads it.",
  },
];

export default function ProblemSection() {
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="bg-[#EAE7DF] py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-[#D96C32]">
            The Problem
          </span>
          <h2
            data-testid="problem-headline"
            className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#1A1D1A] leading-tight"
          >
            Too many tools. Too many steps. Too much room for error.
          </h2>
          <p className="mt-5 text-lg text-[#4A4F4A] leading-relaxed">
            Most farms juggle three or four pieces of kit just to get through a
            session. Arvo replaces that with one workflow you can run from a
            phone in your pocket.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
          {points.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`problem-card-${p.title.toLowerCase().replace(/\s/g, "-")}`}
                className="bg-white border border-[#D5D1C8] rounded-md p-4 sm:p-6 shadow-sm hover:border-[#2D4A22] transition-colors"
              >
                <div className="inline-flex w-10 h-10 sm:w-12 sm:h-12 items-center justify-center rounded-md bg-[#F9F8F6] border border-[#D5D1C8]">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-[#2D4A22]" strokeWidth={2} />
                </div>
                <h3 className="mt-4 sm:mt-5 font-display font-bold text-base sm:text-lg text-[#1A1D1A]">
                  {p.title}
                </h3>
                <p className="mt-1.5 sm:mt-2 text-sm text-[#4A4F4A] leading-relaxed">
                  {p.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
